module.exports = __webpack_public_path__ + "img/chevron-up.40c54f1e.svg";